module.exports = __webpack_public_path__ + "static/badge-1-82de137622bd0c2bf5b4041d62d613ec.png";